/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Text from 'components/Text.jsx';

import './styles/FooterNavColumn.scss';

type Props = {
  // `?` for flow - https://github.com/facebook/flow/issues/1964
  children?: React.Node,
  className?: string,
  title?: string,
};

class FooterNavColumn extends React.Component<Props> {
  renderTitle() {
    const { title } = this.props;
    if (!title) {
      return null;
    }
    return (
      <Text
        color="thunder"
        element="h3"
        size="xxxxsmall"
        uppercase
        weight="semibold"
        className="FooterNavColumn-title">
        {title}
      </Text>
    );
  }

  render() {
    const { children, className } = this.props;

    return (
      <div className={cx('FooterNavColumn', className)}>
        {this.renderTitle()}
        {children}
      </div>
    );
  }
}

export default FooterNavColumn;
